import { omniaPromise, OmniaPromise } from "../promises"
import { OmniaDialogSize } from "../shell"
import { classes } from "./react"

export interface DialogContentOptions<Result> {
    close: (result: Result) => void
}

interface ShowDialogOptions<Props, Result> {
    content: React.FunctionComponent<Props & DialogContentOptions<Result>>
    contentProps?: Props

    size?: OmniaDialogSize
    cssClass?: string
}

let backdrop: HTMLElement
let windows: HTMLElement[] = []

export function showDialog<Props, Result>({
    content,
    contentProps,
    size,
    cssClass,
}: ShowDialogOptions<Props, Result>): OmniaPromise<Result> {
    backdrop = backdrop || createRoot("omnia-modal-backdrop", "modal-backdrop fade ng-scope in", 1050)

    const w = createWindow(size || "md", windows.length, cssClass)
    windows.push(w.window)

    return omniaPromise((resolve) => {
        const modalProps = {
            ...contentProps,

            close: (result: Result) => {
                windows.remove((i) => i == w.window)
                w.window.remove()

                if (!windows.length) {
                    backdrop.remove()

                    // 2025-03-31
                    // There is currently more than one method of opening/closing bootstrap-style modal dialogs
                    // We must also check if the _other_ method has an open dialog, before we remove this body class.
                    if (!document.body.querySelectorAll(".modal.in").length) {
                        // Safe to remove.
                        document.body.classList.remove("modal-open")
                    }

                    backdrop = undefined
                }

                resolve(result)
            },
        }

        document.body.classList.add("modal-open")

        const element = React.createElement(content, modalProps)
        ReactDOM.render(element, w.content)
    })
}

function createRoot(id: string, cssClass: string, zIndex: number) {
    const e = document.createElement("div") as HTMLElement
    e.setAttribute("id", id)
    e.setAttribute("class", cssClass)
    e.style.zIndex = zIndex.toString()
    document.body.appendChild(e)

    return e
}

function createWindow(size: OmniaDialogSize, index: number, cssClass: string) {
    const createElement = (parent: HTMLElement, cssClass: string) => {
        const e = document.createElement("div")
        e.setAttribute("class", cssClass)
        parent.appendChild(e)
        return e
    }

    const window = createRoot("omnia-react-modal-window", classes("modal fade in", cssClass), 1150 + (index + 1) * 50)
    window.style.display = "block"

    const dlg = createElement(window, `modal-dialog modal-${size}`)

    const content = createElement(dlg, "modal-content")

    return { window, content }
}
